const fundManagement = [
  {
    // 首页主要内容
    path: '/index',
    name: 'index',
    component: (resolve) => require(['@/views/index/index.vue'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  },
  // {
  //   path: '/ib-dashboard',
  //   name: 'IBDashboard',
  //   component: (resolve) => require(['@/views/index/ibdashboard/index.vue'], resolve),
  //   meta: {
  //     isShow: true,
  //     isHide: true
  //   }
  // },
  {
    // Bonus页面
    path: '/bonus',
    name: 'bonus',
    component: (resolve) => require(['@/views/bonus/index.vue'], resolve),
    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 积分商城页面
    path: '/pointsMall',
    name: 'pointsMall',
    component: (resolve) => require(['@/views/pointsMall/index/index.vue'], resolve),
    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 我的积分页面
    path: '/myPoints',
    name: 'myPoints',
    component: (resolve) => require(['@/views/pointsMall/myPoints/index.vue'], resolve),
    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 我的兑换页面
    path: '/myExchange',
    name: 'myExchange',
    component: (resolve) => require(['@/views/pointsMall/myExchange/index.vue'], resolve),

    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 活动详情页面
    path: '/pointsMallDeatil/:id',
    name: 'PointsMallDeatil',
    component: (resolve) => require(['@/views/pointsMall/pointsMallDeatil/index.vue'], resolve),

    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 积分商城说明
    path: '/settingsIntro',
    name: 'SettingsIntro',
    component: (resolve) => require(['@/views/pointsMall/settingsIntro/index.vue'], resolve),
    meta: {
      isShow: true,
      isHide: true,
      isPermission: true
    }
  },
  {
    // 入金
    path: '/deposit',
    name: 'deposit',
    component: (resolve) =>
      localStorage.getItem('useGoldOldVersion') === '1'
        ? require(['@/views/danaharta/golden/index'], resolve)
        : require(['@/views/danaharta/golden/v2/guide/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'Deposit',
      isPermission: true
    }
  },
  {
    // 入金
    path: '/deposit-method/:type/:name',
    name: 'deposit-method',
    component: (resolve) => require(['@/views/danaharta/golden/v2/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'Deposit',
      isPermission: false
    }
  },
  {
    // 出金
    path: '/with-draw',
    name: 'with-draw',
    component: (resolve) =>
      localStorage.getItem('useGoldOldVersion') === '1'
        ? require(['@/views/danaharta/inBank/withdraw'], resolve)
        : require(['@/views/danaharta/inBank/v2/guide/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'Withdrawal',
      isPermission: true
    }
  },
  {
    path: '/with-draw/:type/:name',
    name: 'withdraw-method',
    component: (resolve) => require(['@/views/danaharta/inBank/v2/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'Deposit',
      isPermission: false
    }
  },
  {
    // 内部转账
    path: '/inBank',
    name: 'inBank',
    component: (resolve) => require(['@/views/danaharta/inBank/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'InternalTransfer',
      isPermission: true
    }
  },
  {
    // 审核记录
    path: '/auditRecord',
    name: 'auditRecord',
    component: (resolve) => require(['@/views/danaharta/auditRecord/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'AuditRecord',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 审核详情
    path: '/auditDetails',
    name: 'auditdetails',
    component: (resolve) => require(['@/views/danaharta/auditDetails/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'AuditRecord',
      keepAlive: true
    }
  },
  {
    // mt账号资金流水
    path: '/mtIdJR',
    name: 'mtIdJR',
    component: (resolve) => require(['@/views/danaharta/capitalFlow/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'MTaccountFundsFlow',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 钱包流水
    path: '/walletWater/:id?',
    name: 'walletWater',
    component: (resolve) => require(['@/views/danaharta/walletWater/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'PurseFlow',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 钱包流水详情
    path: '/wallet-detail',
    name: 'wallet-detail',
    component: (resolve) => require(['@/views/danaharta/walletDetail/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'PurseFlow'
    }
  },
  {
    // 资金密码
    path: '/moneyPassword',
    name: 'moneyPassword',
    component: (resolve) => require(['@/views/danaharta/moneyPassword/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'FundPassword',
      isPermission: true
    }
  },
  {
    // 上传凭证
    path: '/uploading',
    name: 'uploading',
    component: (resolve) => require(['@/views/danaharta/uploading/index'], resolve),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'Deposit'
    }
  },
  {
    path: '/payment-orders',
    name: 'payment-orders',
    component: () => import('../views/danaharta/paymentOrder/index'),
    meta: {
      crumbsOne: 'MoneyManagement',
      crumbsTow: 'paymentOrder',
      keepAlive: true,
      isPermission: true
    }
  }
]

export default fundManagement
